import React, { useState, useEffect, useMemo } from "react";
import { useHistory,useLocation } from "react-router-dom";
import StarRatings from "react-star-ratings";

import {UncontrolledCollapse,NavbarBrand,Navbar,Container,Row,Col,Card,CardHeader,CardBody,
  Button,Form,FormGroup,Input,CustomInput,} from "reactstrap";
import DatePicker from "react-datepicker";

import { jobReg } from "../../network/ApiAxios";


import "react-datepicker/dist/react-datepicker.css";
import 'assets/css/customDatePickerWidth.css';

const JobRoute = () => {
  
  //const [referer, setReferer] = useState();
  /*
  let { search } = useLocation(); //get referer from url
  
  if(search){
    search = useMemo(() => {
      new URLSearchParams(search), [search]
    })
    //setReferer(search.get('referer'))
  }

  const referer=useMemo(() => {
    console.log(search)
    new URLSearchParams(search)
    return search.split('=')[1]
  }, [search])
  console.log(referer)
*/
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();
  const [birthday, setbirthday] = useState();
  const [adress, setAdress] = useState();
  const [country, setCountry] = useState();
  const [facebook, setFacebook] = useState();
  const [instagram, setInstagram] = useState();
  const [Picture, setPicture] = useState();
  const [CV, setCV] = useState();
  const [position, setPosition] = useState();
  const [sDate, setSDate] = useState(new Date());
  const [eDate, setEDate] = useState();
  const [exp, setexp] = useState();
  const [about, setabout] = useState();
  const [msg, setmsg] = useState();
  const [show, setshow] = useState(false);
  const [enLang, setEnLang] = useState(0);
  const [nlLang, setNlLang] = useState(0);
  const [ptLang, setPtLang] = useState(0);
  const [otherLang, setOtherLang] = useState('');
  const [aboutUs, setAboutUs] = useState('');
  const [workplace, setWorkplace] = useState('');
  
  const regJob = async (e) => {
    e.preventDefault();
    const conditionsArray = [
      name !== undefined,
      email !== undefined,
      phone !== undefined,
      birthday !== undefined,
      //adress !== undefined,
      country !== undefined,
      //instagram !== undefined,
      position !== undefined,
      sDate !== undefined,
      eDate !== undefined,
      exp !== undefined,
      about !== undefined,
      Picture !== undefined,
    ];

    if (conditionsArray.indexOf(false) === -1) {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("email", email);
      formData.append("pass", "celebrationjump");
      formData.append("phone", phone);
      formData.append("birthday", birthday);
      formData.append("adress", adress);
      formData.append("country", country);
      formData.append("facebook", facebook);
      formData.append("instagram", instagram);
      formData.append("position", position);
      formData.append("sDate", sDate);
      formData.append("eDate", eDate);
      formData.append("exp", exp);
      formData.append("about", about);
      formData.append("picture", Picture);
      formData.append("CV", CV);
      //referer && formData.append("referer", referer);
      formData.append("enLang", enLang);
      formData.append("nlLang", nlLang);
      formData.append("ptLang", ptLang);
      formData.append("otherLang", otherLang);
      formData.append("aboutUs", aboutUs);
      formData.append("workplace", workplace);

      
      
      const res = await jobReg(formData);
      console.log(res.data)
      if (res.data.success) {
        setName("");
        setEmail("");
        setPhone("");
        setbirthday("");
        setAdress("");
        setCountry("");
        setFacebook("");
        setInstagram("");
        setPicture("");
        setCV("");
        setPosition("");
        setSDate(new Date());
        setexp("");
        setabout("");
        setEnLang(0);
        setNlLang(0);
        setPtLang(0);
        setOtherLang('');
        setAboutUs('');
        setWorkplace('');
        setshow(true);
      } else {
        setmsg(res.data.msg);
      }
    } else {
      setmsg("You need to fill all the fields");
    }
  };

  function subDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() - days);
    return result;
  }

  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  return (
    <>
      <Navbar
        className="navbar-top navbar-horizontal navbar-blue"
        expand="md"
        style={{
          background: "linear-gradient(87deg, #11cdef 0, #1171ef 100%)",
        }}
      >
        <Container className="px-4 ">
          <NavbarBrand>
            <img
              alt="..s."
              src={require("../../assets/img/brand/argon-react.png").default}
              style={{ height: "50px" }}
            />
          </NavbarBrand>
          <button className="navbar-toggler" id="navbar-collapse-main">
            <span className="navbar-toggler-icon" />
          </button>
          <UncontrolledCollapse navbar toggler="#navbar-collapse-main">
            <div className="navbar-collapse-header d-md-none">
              <Row>
                <Col className="collapse-brand" xs="6">
                  <img
                    alt="..."
                    src={require("../../assets/img/brand/argon-react.png").default}
                  />
                </Col>
                <Col className="collapse-close" xs="6">
                  <button className="navbar-toggler" id="navbar-collapse-main">
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
          </UncontrolledCollapse>
        </Container>
      </Navbar>
      <Container className="mt-4" fluid hidden={show}>
        <Row>
          <div className="col">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0"> Information </h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form
                  id="myform"
                  onSubmit={regJob}
                  encType="multipart/form-data"
                >
                  <div className="pl-lg-4">
                    <h6 className="heading-small text-muted mb-4">
                      User information
                    </h6>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-username"
                          >
                            Full Name
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-username"
                            placeholder="Username"
                            onChange={(e) => setName(e.target.value)}
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-email"
                          >
                            Email address
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-email"
                            onChange={(e) => setEmail(e.target.value)}
                            type="email"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-phone"
                          >
                            Phone Number
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-phone"
                            placeholder="Phone"
                            onChange={(e) => setPhone(e.target.value)}
                            type="number"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-birthday"
                          >
                            Birthday
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-birthday"
                            onChange={(e) => setbirthday(e.target.value)}
                            type="date"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                    <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-country"
                          >
                            Country
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-country"
                            placeholder="Country"
                            onChange={(e) => setCountry(e.target.value)}
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-profilepicture"
                          >
                            Profile Picture
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-profilepicture"
                            onChange={(e) => setPicture(e.target.files[0])}
                            type="file"
                            accept="image/*"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <hr></hr>
                    <h6 className="heading-small text-muted mb-4">
                      CV and Work Experience
                    </h6>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-idpicture"
                          >
                            Upload CV(PDF Only)
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-idpicture"
                            onChange={(e) => setCV(e.target.files[0])}
                            type="file"
                            accept="application/pdf"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label htmlFor="exampleSelectMultiPosition" className="form-control-label">
                            Position(Use CTRL to select multiple)
                          </label>
                          <Input
                            id="exampleSelectMultiPosition"
                            multiple
                            name="selectMulti"
                            type="select"
                            onChange={e => {
                              const options = [...e.target.selectedOptions];
                              const values = options.map(option => option.value);
                              console.log(values.toString())
                              setPosition(values.toString());
                            }}
                            className="form-control-alternative customMultipleSelect"
                          >
                            <option value={'Ticket Seller'}>Ticket Seller</option>
                            <option value={'Bartender'}>Bartender</option>
                            <option value={'Security'}>Security</option>
                            <option value={'Manager'}>Manager</option>
                            <option value={'VIP Hostess'}>VIP Hostess</option>
                            <option value={'Waiter'}>Waiter</option>
                            <option value={'Proper/Tout'}>Proper/Tout</option>
                            <option value={'Shot Girl'}>Shot Girl</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-idpicture"
                          >
                            Start Date(Approximate)
                          </label>
                          <div className="customDatePickerWidth">
                            <DatePicker
                              //className="form-control-alternative"
                              selected={sDate}
                              onChange={(date) => setSDate(date)}
                              excludeDateIntervals={[
                                { start: subDays(new Date(), 300), end: new Date() },
                              ]}
                              dateFormat="dd/MM/yyyy"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-driverlicense"
                          >
                            End Date(Approximate)
                          </label>
                          <div className="customDatePickerWidth">
                            <DatePicker
                              className="form-control-alternative"
                              selected={eDate}
                              onChange={(date) => setEDate(date)}
                              excludeDateIntervals={[
                                { start: subDays(new Date(), 300), end: addDays(sDate, 30) },
                              ]}
                              dateFormat="dd/MM/yyyy"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-idpicture"
                          >
                            Years of Experience(In Hospitality)
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-birthday"
                            onChange={(e) => setexp(e.target.value)}
                            type="number"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-instagram"
                          >
                            Instagram
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-instagram"
                            placeholder="https://www.instagram.com/"
                            onChange={(e) => setInstagram(e.target.value)}
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label mr-2"
                            htmlFor="input-idpicture"
                          >
                            English Proficiency
                          </label>
                          <StarRatings
                            rating={enLang ? enLang : 0}
                            starRatedColor="blue"
                            changeRating={setEnLang}
                            numberOfStars={5}
                            name="rating"
                            starDimension="30px"
                            starSpacing="2px"
                            onChange={(e) => setEnLang(e.target.value)}
                          />
                          <br></br>
                          <label
                            className="form-control-label mr-2"
                            htmlFor="input-idpicture"
                          >
                            Portuguese Proficiency
                          </label>
                          <StarRatings
                            rating={ptLang ? ptLang : 0}
                            starRatedColor="blue"
                            changeRating={setPtLang}
                            numberOfStars={5}
                            name="rating"
                            starDimension="30px"
                            starSpacing="2px"
                            onChange={(e) => setPtLang(e.target.value)}
                          />
                          <br></br>
                          <label
                            className="form-control-label mr-2"
                            htmlFor="input-idpicture"
                          >
                            Dutch Proficiency
                          </label>
                          <StarRatings
                            rating={nlLang ? nlLang : 0}
                            starRatedColor="blue"
                            changeRating={setNlLang}
                            numberOfStars={5}
                            name="rating"
                            starDimension="30px"
                            starSpacing="2px"
                            onChange={(e) => setNlLang(e.target.value)}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label htmlFor="exampleSelectMulti" className="form-control-label">
                            Other Languages(Use CTRL to select multiple)
                          </label>
                          <Input
                            id="exampleSelectMulti"
                            multiple
                            name="selectMulti"
                            type="select"
                            onChange={e => {
                              const options = [...e.target.selectedOptions];
                              const values = options.map(option => option.value);
                              setOtherLang(values);
                            }}
                            className="form-control-alternative customMultipleSelect"
                          >
                            <option value={'Mandarin'}>Mandarin Chinese</option>
                            <option value={'Spanish'}>Spanish</option>
                            <option value={'Italian'}>Italian</option>
                            <option value={'French'}>French</option>
                            <option value={'German'}>German</option>
                            <option value={'Arabic'}>Arabic</option>
                            <option value={'Russian'}>Russian</option>
                            <option value={'Hindi'}>Hindi</option>
                            <option value={'Bengali'}>Bengali</option>
                            <option value={'Japanese'}>Japanese</option>
                            <option value={'Punjabi'}>Punjabi</option>
                            <option value={'Korean'}>Korean</option>
                            <option value={'Turkish'}>Turkish</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                        <label
                            className="form-control-label"
                            htmlFor="input-aboutus"
                          >
                            Where did you hear about us
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-aboutus"
                            placeholder="Friend/Instagram/Google/Job website"
                            onChange={(e) => setAboutUs(e.target.value)}
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-workplace"
                          >
                            Prefered workplace
                          </label>
                          <div className="customSelect">
                            <Input
                              type="select"
                              name="select"
                              id="input-workplace"
                              onChange={(e) => setWorkplace(e.target.value)}
                            >
                              <option>Select 1</option>
                              <option>Club Heaven</option>
                              <option>Albufeira 66</option>
                              <option>Club Tropicana</option>
                              <option>Heaven Beach Club</option>
                              <option>Albufissa</option>
                              <option>Warehouse</option>
                              <option>Ticket Shop</option>
                            </Input>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-idpicture"
                          >
                            Motivation for working abroad
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-birthday"
                            onChange={(e) => setabout(e.target.value)}
                            type="textarea"
                            style={{ height: "100px" }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                </Form>
              </CardBody>
              {msg ? (
                <span
                  className="mb-2"
                  style={{
                    backgroundColor: "red",
                    height: "50px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {msg}
                </span>
              ) : (
                ""
              )}
              <Row className="mb-4 justify-content-center d-flex">
                <Button
                  color="primary"
                  type="submit"
                  form="myform"
                  size="sm"
                  style={{
                    height: "100px",
                    width: "100px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Send
                </Button>
              </Row>
            </Card>
          </div>
        </Row>
      </Container>
      <Container
        className="mt-4"
        style={{ textAlignLast: "center" }}
        fluid
        hidden={!show}
      >
        <h1> Your job application was succesfully registered. </h1>
      </Container>
      
    </>
  );
};

export default JobRoute;
//<AuthFooter/>